module.exports.premium = "#FBC02D";
module.exports.partner = "#993299";
module.exports.verified = {
  clan: "#FBC02D",
  player: "#40C4FF"
};
module.exports.getClanCol = function (p4687, p4688) {
  if (p4687 == "DEV") {
    return "#40C4FF";
  }
  if (p4687 == "VIP") {
    return "#11D445";
  } else if (p4687 == "CMD") {
    return "#993299";
  } else {
    return p4688;
  }
};
module.exports.easterPalette = ["#ffd45e", "#61fff7", "#ff63d8"];
module.exports.damage = "#DE292F";
module.exports.critical = "#FFD542";
module.exports.ready = "#32CD32";
module.exports.crosshair = {
  background: "#ffffff",
  shadow: "#000000"
};
module.exports.hudHealth = {
  low: "#eb5656",
  high: "#9eeb56"
};
module.exports.popupScore = "#ffea78";
module.exports.ping = {
  unknown: "grey",
  low: "rgb(158, 235, 86)",
  medium: "rgb(255, 213, 66)",
  high: "rgb(255, 75, 66)"
};
module.exports.teams = ["#9eeb56", "#eb5656"];
module.exports.creationDate = {
  new: "#0a61f7",
  recent: "#E040FB",
  old: "#ed4242"
};
module.exports.matchVote = {
  selected: "rgba(251, 192, 45, 1)",
  notSelected: "rgba(255, 255, 255, 0.7)"
};
module.exports.killFeed = {
  enemy: "#eb5656",
  ally: "#9eeb56",
  you: "#fff"
};
module.exports.interactPopup = {
  key: "#FBC02D",
  enough: "#9eeb56",
  notEnough: "#eb5656"
};
module.exports.zones = {
  BR: ["#c542d9", "#c542d9", "#c542d9"],
  sky: ["#74a4b9", "#dce8ed", "#dce8ed"]
};